import React, { Fragment, useState } from 'react';
import InfoDevLayout from '../components/infoDevLayout/infoDevLayout';
import InfoDevMensaje from '../components/infoDevMensaje/infoDevMensaje';
import InfoDevRegExito from '../components/infoDevRegExito/infoDevRegExito';
import { LAYOUT_PAG } from '../constants/content_pag';

const InformacionDevolucion = () => {

  const [ polizaMensaje, mostrarPolizaMensaje ] = useState(LAYOUT_PAG.PAG_MEN);

  const mostrarPaginaInfDev = () => {
    switch(polizaMensaje) {
      case LAYOUT_PAG.PAG_MEN  : return <InfoDevMensaje mostrarPolizaMensaje={mostrarPolizaMensaje}/>;
      case LAYOUT_PAG.PAG_LAY  : return <InfoDevLayout mostrarPolizaMensaje={mostrarPolizaMensaje}/>;
      case LAYOUT_PAG.PAG_EXI  : return <InfoDevRegExito />
      default : return <h1>Pagina en construcción</h1>
    }
  }

  return ( 
    <Fragment>
      { mostrarPaginaInfDev() }
    </Fragment>
  );
}
 
export default InformacionDevolucion;